import React, { useEffect, useState } from "react";
import axios from "../../axios";
import Header from "../../Layout/Header/Header";

const Kontakt = (props) => {
  const [headingText, setHeadingText] = useState("");

  useEffect(() => {
    axios.get("/singletons/get/contact").then((res) => {
      setHeadingText(res.data.text);
    });
  }, []);

  return (
    <div>
      <Header small={true} />
      <main>
        <div dangerouslySetInnerHTML={{ __html: headingText }}></div>
      </main>
    </div>
  );
};

export default Kontakt;
